export const getTotalFilters = ({
  selectedCategoryIds,
  selectedUnitIds,
  selectedPriorityIds,
  waitingOnParts,
  noAccess,
  activeOrders,
  postErrorOrders,
  isCallback,
  notPosted
}) => {

  let total = 0;

  const filters = [selectedPriorityIds?.length > 0, selectedUnitIds?.length > 0, selectedCategoryIds?.length > 0, waitingOnParts, noAccess, activeOrders, postErrorOrders, isCallback, notPosted];
  filters.forEach((item) => {
    if (item) total += 1;
  });

  return total;
}